'use strict';

function fSliderMedia () {
    const aSliders = document.querySelectorAll('.js-slider-media');

    function fInitSlider (oSlider) {
        const oList = oSlider.querySelector('.js-slider-media-list');
        const oListItems = oSlider.querySelectorAll('.js-slider-media-item');
        const oNav = document.querySelector('.js-slider-media-nav');
        const oButtonPrev = oSlider.querySelector('.js-slider-media-prev');
        const oButtonNext = oSlider.querySelector('.js-slider-media-next');

        let oFlickity = new Flickity(oList, {
            wrapAround: true,
            prevNextButtons: false,
            on: {
                ready: function() {
                    oNav.style.display = 'block';

                    if (oButtonPrev) oButtonPrev.addEventListener('click', function () { oFlickity.previous(); });
                    if (oButtonNext) oButtonNext.addEventListener('click', function () { oFlickity.next(); });

                    for (let a = 0; a < oListItems.length; a += 1) {
                        oListItems[a].style.height = '100%';
                    }
                }
            }
        });
    }

    for (let a = 0; a < aSliders.length; a += 1) {
        fInitSlider(aSliders[a]);
    }
}